export default {
  'goldkid-more:text': 'Подробнее'
}
